module.exports = __webpack_public_path__ + "img/demo_man1.48f50173.svg";